import React from "react";
import Question from "../Global/Question";

const Roles = (props) => {
  return <Question {...props} />;
};

export default Roles;
